import { render, staticRenderFns } from "./PolizzaForm.vue?vue&type=template&id=0eebef11"
import script from "./PolizzaForm.vue?vue&type=script&lang=js"
export * from "./PolizzaForm.vue?vue&type=script&lang=js"
import style0 from "./PolizzaForm.vue?vue&type=style&index=0&id=0eebef11&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports